// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css'
import 'flex.css'
import './less/common.css'
import './less/mint-ui.css'
import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store/index'
import Mint from 'mint-ui'
Vue.use(Mint)
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "./common/font/font.css";

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.getConfigJson=function(){
    axios.get("serverconfig.json").then((result)=>{
        //用一个全局字段保存ApiUrl  也可以用sessionStorage存储
       Vue.prototype.ApiUrl=result.ApiUrl;
    }).catch((error)=>{console.log(error)});
}
/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },

})



// WEBPACK FOOTER //
// ./src/main.js